import { useState } from 'react';

export function useConfirmModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null);

  const showConfirmModal = (message: string, callback: () => void) => {
    setMessage(message);
    setOnConfirm(() => callback);
    setIsOpen(true);
  };

  const handleConfirm = () => {
    onConfirm?.();
    setIsOpen(false);
    setMessage('');
    setOnConfirm(null);
  };

  const handleCancel = () => {
    setIsOpen(false);
    setMessage('');
    setOnConfirm(null);
  };

  return { isOpen, message, onConfirm, showConfirmModal, handleConfirm, handleCancel };
}
